<template>
  <div class="content">
    <div>
      <div class="main-title">
        <h4>
          Lista de Spare Parts
        </h4>
      </div>
    </div>

    <div v-if="configInputs != 1">
      <div>
        <div class="row-1">
          <div class="one">
            <label> Descrição:</label>
            <input
              v-model="v$.desc.$model"
              type="text"
              :class="['field', { error: v$.desc.$error }]"
            />
            <div class="text-red" v-if="v$.desc.$error">
              O campo Descrição deve conter no mínimo 3 caracteres.
            </div>
          </div>

          <div class="one">
            <label> Quantidade: </label>
            <input
              v-model="v$.quantidade.$model"
              v-maska="['##', '']"
              :class="['field', { error: v$.quantidade.$error }]"
            />
            <div class="text-red" v-if="v$.quantidade.$error">
              O campo quantidade deve conter no mínimo 1 valor numerico.
            </div>
          </div>

          <div class="one">
            <label> Observação: </label>
            <input
              v-model="v$.observacao.$model"
              type="text"
              class="form-control"
              :class="['field', { error: v$.observacao.$error }]"
            />
            <div class="text-red" v-if="v$.observacao.$error">
              O campo Descrição deve conter no mínimo 3 caracteres.
            </div>
          </div>
          <div class="one">
            <label style="color: #cccccc00;"> Imagem</label>
              <div style="display: flex; gap: 1rem;">
                <label :class="['buttonaddimage', { 'image-added': file !== '' }]" for="fotoSpareParts">
                  <p v-if="file==''">Adicionar Imagem</p>
                  <p v-if="file!==''" style="font-size: 0.7rem;">Imagem Adicinada ✓</p>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  @change="addFiles"
                  id="fotoSpareParts"
                  name="fotoSpareParts"
                  hidden
                />
                 <div class="btn-produto">
                <button
                  @click="addInList"
                  type="button"
                  class="btn-button-produto"
                >
                </button>
                </div>
              </div>
          </div>

          <div>
            <label
              v-if="configInputs == 0"
              for="fotoSparePartsEdit"
              ></label>
            <label
              v-else
              for="fotoSparePartsEdit"
              ></label>
            
            <input
              v-if="configInputs == 0"
              type="file"
              @change="addFiles"
              id="fotoSparePartsEdit"
              name="fotoSparePartsEdit"
              hidden
            />
            <input v-else type="file" @change="addFiles" id="fotoSpareParts" />

            <button
              @click="addInList"
              type="button"
            >
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tableHistorico" v-if="list_lsp.length>0">
      <table class="table">
        <thead>
          <tr>
            <!-- <th>Id</th> -->
            <td colspan="col">Descrição</td>
            <td colspan="col">Quantidade</td>
            <td colspan="col">Observação</td>
            <td colspan="col">Preview</td>
            <td v-if="configInputs != 1">Opção</td>
          </tr>
        </thead>
        <tbody v-for="l in list_lsp" :key="l.idp">
          <tr>
            <td style="display: none"></td>
            <td data-title="Descrição">{{ l.desc }}</td>
            <td data-title="Quantidade">{{ l.quantidade }}</td>
            <td data-title="Observação">{{ l.observacao }}</td>
            <td data-title="Preview">
              <div class="image-section">
                <button type="button" @click="clickPreview(l.preview)" class="button-image">
                  <img height="50" width="50" :src="l.preview" class="image-view"/>
                </button>
              </div>
            </td>
            <td v-if="configInputs != 1" class="btnDelete">
              <button type="button" @click="clickDeleteLSP(l.id)">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <h3 class="warning-none">Nenhum Spare part adicionado</h3>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, minValue } from "@vuelidate/validators";
export default {
  props: {
    configInputs: Number,
  },
  async created() {
    await this.ConstructViewRRIM();
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      list_lsp: [],
      count: 0,
      id: "",
      desc: "",
      quantidade: "",
      observacao: "",
      preview: "",
      file: "",

      ListLSP: "",
    };
  },

  watch: {
    list_lsp: {
      deep: true,
      immediate: true,
      handler(newValue, OldValue) {
        this.$store.commit("MutationImagesLSP", newValue);
      },
    },
  },

  validations() {
    return {
      desc: {
        minLength: minLength(3),
      },
      quantidade: {
        minValueValue: minValue(1),
      },
      observacao: {
        minLength: minLength(3),
      },
    };
  },

  methods: {
    addFiles(event) {


      var input = event.target;

      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.preview = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    addInList() {
      if (
        this.v$.desc.$invalid == true ||
        this.v$.quantidade.$invalid == true ||
        this.v$.observacao.$invalid == true ||
        this.v$.desc.$model == "" ||
        this.v$.quantidade.$model == "" ||
        this.v$.observacao.$model == "" ||
        this.file == ""
      ) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique os dados inputados !",
        });
      } else {
        this.count += 1;
        this.id = this.count;
        const data = {
          id: this.id,
          desc: this.desc,
          quantidade: this.quantidade,
          observacao: this.observacao,
          preview: this.preview,
          file: this.file,
        };

        this.list_lsp.push(data);
        this.$store.commit("MutationImagesLSP", this.list_lsp);
      }
    },

    clickPreview(base64) {
      this.$swal.fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: 'Baixar',
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: 'preview-modal-popup',
            image: 'preview-modal-image',
            confirmButton: 'preview-modal-button'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = 'imagem.jpg'; 
            link.click();
          }
      });
      //  this.$swal('Hello Vue world!!!');
    },

    clickDeleteLSP(id) {
      let index = this.list_lsp.findIndex((element) => element.id === id);

      this.list_lsp.splice(index, 1);

      this.$store.commit("MutationImagesLSP", this.list_lsp);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.ListSpareParts) {
        dataQuery.ListSpareParts.map((element) => {
          this.list_lsp.push({
            id: element.ID,
            desc: element.DESCRIPTION,
            quantidade: element.QUANTIDADE,
            observacao: element.OBSERVACAO,
            preview: `${this.$store.state.ImgURL}` + `${element.PATH_IMG}`,
            file: "",
          });
        });
      }
    },
  },
};
</script>

<style scoped>

.swal2-image.original-size-image {
  max-width: 90vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 1rem;
}

.image-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-added {
  background-color: #28a745 !important; 
  border: 1px solid #218838;
}

.image-added p {
  color: white;
  font-weight: bold;
}

.row-1{
  gap: 1rem;
  display: flex;
  color: var(--font_color);
  margin-bottom: 0.5rem;
  align-items: top;
  flex-wrap: wrap;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;

}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.field {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 16rem!important;
  padding: 1rem;
  color: var(--font_color);
  
}

.field_select {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 13rem!important;
  color: var(--font_color);
  
}

.field:hover {
  border: 1px solid var(--input_hover)!important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green)!important;
}

.field::placeholder{
  color: rgb(65, 62, 62)!important;
}

.section-field {
  display: flex;
  flex-direction: column;
}

.error {
  border-radius: 10px!important;
  height:2.5rem!important;
  width: 13rem!important;
  padding: 1rem;
  color: var(--font_color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 13rem!important;
  text-align: center;
}

.one {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.buttonaddimage {
  display: flex;
  align-items: center;
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 10rem!important;
  padding: 1rem;
  color: var(--font_color);
  background-color: #a5a4a4;
  cursor: pointer;
}

.buttonaddimage p{
  color: white;
  font-family: 'Poppins', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
}



.btn-button-produto {
  height: 2.3rem!important;
  width: 4rem!important;
  cursor: pointer;
  margin: 0 auto;
  background-image: url(../../../../../static/icons/+.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30%;
  background-color: var(--green);
  border-radius: 0.5rem;

}


.btn-produto {
  display: flex;
  align-items: center;
  align-items: center;
  height:2.5rem!important;
  animation: pulse 0.5s ease-in-out 3;
}

.btn-button-produto:hover {
  background-color: var(--green_hover);
}

.btn-button-produto:focus {
  background-color: var(--green_focus);
}

.sectioncard {
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
}

.sectioncard div{
}

.btnDelete {
cursor: pointer;
background-image: url('../../../../../static/icons/trash.svg')!important;
background-repeat: no-repeat;
background-position: center;
width: 2rem;
}

.btnDelete button{
width: 2rem!important;
height: 2rem!important;

background-color: #d9d9d900;
}

.errormessage {
  font-size: 0.8rem;
  color: red;
  width: 13rem;
  text-align: center;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.content {
  padding: 1rem 2rem!important;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
}

.main-title {
  width: 100%!important;
  text-align: center;
  font-size: 1.4rem;
  padding: 0rem 0rem 1rem;
}

.tableHistorico {
  margin-top: 3rem;
  width: 68rem;
}

thead {
  border-radius: 1rem;
  margin-bottom: 1rem;
}

.table thead tr td:first-child {
  border-top-left-radius: 8px!important;
  border-bottom-left-radius: 8px!important;
}

.table thead tr td:last-child {
  border-top-right-radius: 8px!important;
  border-bottom-right-radius: 8px!important;
}

.tableHistorico tbody tr:first-child td:first-child {
  border-top-left-radius: 8px!important;
  border-bottom-left-radius: 8px;
}

.tableHistorico tbody tr:last-child td:last-child {
  border-top-right-radius: 8px!important;
  border-bottom-right-radius: 8px;
}

thead tr td{
  font-size: 0.9rem;
  background-color: var(--green);
  color: white;
  margin: 1rem!important;
  height: 1.5rem!important;
  padding: 0rem 1rem;
}

tbody tr td{
  padding: 0.5rem!important;
}


.image-view {
  border-radius: 0.5rem !important;
  width: 50px;
  height: 50px;
  object-fit: cover; 
}

.button-image {
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.warning-none {
  text-align: center;
  color: red;
}

@media screen and (max-width: 1200px) {
  .tableHistorico {
    width: 100%;
  }

  .tableHistorico table,
  .tableHistorico thead,
  .tableHistorico tbody,
  .tableHistorico th,
  .tableHistorico td,
  .tableHistorico tr {
    display: block;
    width: 100%;
  }

  .tableHistorico thead {
    display: none; 
  }

  .tableHistorico tr {
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    padding: 1rem;
    background: #f9f9f9;
  }

  .tableHistorico td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;
    width: 100%;
  }

  .tableHistorico td::before {
    content: attr(data-title);
    font-weight: bold;
    flex: 1;
    padding-right: 1rem;
    text-align: left;
    color: #333;
  }

  .tableHistorico td:last-child {
    border-bottom: none;
  }

  .image-section {
    justify-content: flex-end;
  }

  .button-image img {
    margin-left: auto;
  }
}
</style>